"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = void 0;
/**
 * Exhaustiveness guard for switches over closed unions and enums.
 *
 * Put it in the `default:` arm instead of a fallback value. A missing case then
 * becomes a COMPILE error rather than a silent wrong answer — which is the
 * whole point here: the status switches this guards used to end
 * `case Status.Good: default:`, so a new status member rendered GREEN with a
 * clean `tsc`. An offline sensor showing green is the worst possible failure
 * mode for this feature, and it was invisible to the compiler.
 *
 * Throws at runtime only if reached via untyped data (a raw GraphQL string),
 * so callers that can receive unvalidated input should branch explicitly
 * rather than rely on this.
 */
function assertNever(value) {
    throw new Error(`Unhandled case: ${String(value)}`);
}
exports.assertNever = assertNever;
